import { CornerDTO } from './CornerDTO';
import { RoomDTO } from './RoomDTO';
import { WallDTO } from './WallDto';

export class FloorplanDTO {
  public static getEmptyFloorplan() {
    return new FloorplanDTO(undefined, [], [], []);
  }

  public id: number | undefined;
  public walls: WallDTO[];
  public corners: CornerDTO[];
  public rooms: RoomDTO[];

  constructor(id: number | undefined, walls: WallDTO[], rooms: RoomDTO[], corners: CornerDTO[]) {
    this.id = id;
    this.walls = walls;
    this.rooms = rooms;
    this.corners = corners;
  }
}
